/* eslint-disable global-require */
module.exports = ['ails.landingpage.sales.sale.lot.m1'];
